import Button from '@doordash/component-button'
import { Text, StackChildren } from '@doordash/design-language'
import { CountryCode } from '@doordash/lib-i18n'
import * as moment from 'moment-timezone'
import * as React from 'react'
import WhatToBringManager from './whattobringmanager'
import WhatToExpectManager from './whattoexpectmanager'
import { pageLoad, Steps } from '../../../utilities/steps'
import t from './strings'
import { VehicleType } from '../../../constants'

type ScheduleOrientationDetailsProps = {
  orientation: {
    startTime: string
    address: string
  }
  country: CountryCode
  uniqueLink: string
  timezone: string
  clearOrientation: any
  vehicleType: VehicleType
  dasherId?: string
  shouldShowVerifyIdentity?: boolean
  shouldShowWhatToBringManager?: boolean
}
const formatAppointmentTime = (appointmentTime, timezone) =>
  moment(appointmentTime)
    .tz(timezone)
    .format('MMM Do [at] h:mm A')

const ScheduleOrientationDetails: React.FC<ScheduleOrientationDetailsProps> = ({
  orientation,
  country,
  uniqueLink,
  timezone,
  clearOrientation,
  vehicleType,
  shouldShowWhatToBringManager = true,
}) => (
  <StackChildren>
    <Text styles={Text.Styles.Bold24}>{t.h1()}</Text>
    <Text lineHeight={Text.LineHeights.Medium} weight={Text.Weights.Bold}>
      {formatAppointmentTime(orientation.startTime, timezone)}
    </Text>
    <Text lineHeight={Text.LineHeights.Medium}>{orientation.address}</Text>
    <Button
      type={Button.Types.Tertiary}
      onClick={() => clearOrientation(uniqueLink)}
    >
      {t.reschedule()}
    </Button>
    <br />
    <WhatToExpectManager countryCode={country} />
    <br />
    {shouldShowWhatToBringManager ? (
      <WhatToBringManager
        countryCode={country}
        vehicleType={vehicleType || 'default'}
      />
    ) : (
      <Button onClick={() => pageLoad(uniqueLink, Steps.ProgressionCheck)}>
        {t.continue()}
      </Button>
    )}
    <br />
  </StackChildren>
)

export default ScheduleOrientationDetails
